var _defs, _rect, _rect2, _rect3, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    zoomAndPan: "magnify",
    viewBox: "0 0 192 191.999996",
    height: 256,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -19.2,
    width: 230.4,
    fill: "#ffffff",
    y: -19.2,
    height: 230.399995,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -19.2,
    width: 230.4,
    fill: "#ffffff",
    y: -19.2,
    height: 230.399995,
    fillOpacity: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -19.2,
    width: 230.4,
    fill: "#5e17eb",
    y: -19.2,
    height: 230.399995,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.001591, 142.173144)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.867188 -107.902344 L 8.671875 -104.210938 L 22.800781 -104.210938 L 14.933594 5.136719 C 14.453125 11.238281 13.167969 15.894531 11.078125 18.945312 C 8.992188 22.160156 5.621094 25.210938 0.804688 28.101562 L -5.296875 31.632812 L -3.53125 33.71875 L 4.335938 29.542969 C 10.4375 26.332031 14.773438 22.960938 17.339844 19.589844 C 19.910156 16.21875 21.515625 11.078125 22.160156 3.855469 L 30.828125 -104.210938 L 45.601562 -104.210938 L 45.761719 -107.902344 Z M 7.867188 -107.902344 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.603391, 142.173144)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.757812 -104.210938 L 23.605469 -104.210938 L 14.933594 1.445312 L 1.125 1.605469 L 1.925781 5.296875 L 43.03125 4.976562 L 43.191406 1.125 L 22.800781 1.285156 L 26.976562 -49.9375 L 51.0625 -49.9375 C 58.125 -49.9375 59.25 -43.355469 59.089844 -32.273438 L 62.140625 -32.433594 L 65.992188 -71.453125 L 63.105469 -71.292969 C 61.015625 -59.890625 58.609375 -53.308594 51.542969 -53.308594 L 27.296875 -53.308594 L 31.472656 -104.210938 L 66.476562 -104.210938 C 74.664062 -104.210938 77.234375 -97.785156 77.234375 -79.804688 L 80.445312 -81.085938 L 84.460938 -107.902344 L 10.277344 -107.902344 Z M 10.757812 -104.210938 "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.476cff1d22113151253daec9cce26a08.svg";
export { ForwardRef as ReactComponent };